export interface IRegisteredHotkey {
  /** The raw command as authored, e.g. "ctrl+s, cmd+s". */
  command: string;
  friendlyName: string;
}

const registry = new Map<string, IRegisteredHotkey>();

/**
 * Records a live hotkey so the ctrl+/ overlay can list it. `useHotkey` owns the
 * registration — call this directly only if you handle keys without that hook.
 * Registering the same command again replaces the entry rather than duplicating it.
 * @param hotkey the command and the label to show in the overlay.
 * @returns an unregister function; call it when the hotkey stops being live.
 */
export function addHotkeyToRegistry(hotkey: IRegisteredHotkey): () => void {
  registry.set(hotkey.command, hotkey);
  return () => {
    // Identity check so an unmount can't evict a later registration of the same command.
    if (registry.get(hotkey.command) === hotkey) {
      registry.delete(hotkey.command);
    }
  };
}

/** A snapshot of every currently live hotkey, for the ctrl+/ overlay to render. */
export function getRegisteredHotkeys(): IRegisteredHotkey[] {
  return Array.from(registry.values());
}
